import getNumericValue from './getNumericValue';
import getPrefixedNumberFormat from './getPrefixedNumberFormat';
import isNumber from './isNumber';
import round from './round';

export default {
  getNumericValue,
  getPrefixedNumberFormat,
  isNumber,
  round,
};



// WEBPACK FOOTER //
// ./app/utils/numeric/index.js